import React from "react";
import { tattoo, setSex } from "../../state";
import SkinTonePicker from "../../SkinTonePicker.jsx";
import { SKINS } from "../constants";

const skinToneLabelRow = (skinOpen, setSkinOpen) => (
  <div
    className="tt-row"
    style={{ alignItems: "center", gap: 8, marginLeft: "auto", flexShrink: 0 }}
  >
    <span
      className="label"
      style={{
        marginBottom: 0,
        textTransform: "uppercase",
        fontSize: 11,
        letterSpacing: 0.12,
        opacity: 0.85,
      }}
    >
      Skin tone
    </span>
    <button
      type="button"
      className="mini-toggle"
      onClick={() => setSkinOpen((s) => !s)}
      style={{
        width: 28,
        height: 28,
        borderRadius: 999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 16,
        lineHeight: 1,
      }}
    >
      {skinOpen ? "–" : "+"}
    </button>
  </div>
);

export default function SkinToneSection({ snap, skinOpen, setSkinOpen, variant = "desktop" }) {
  const baseStyle = {
    borderRadius: 999,
    border: "1px solid #333",
    background: "#181818",
    color: "#f5f5f5",
    padding: "6px 12px",
    fontSize: 13,
    cursor: "pointer",
    transition: "background 0.15s ease, border-color 0.15s ease, color 0.15s ease",
  };
  const selectedStyle = {
    borderColor: "#a2332b",
    background: "#a2332b",
    color: "#ffffff",
  };

  const sexButtons = ["female", "male"].map((sexOption) => {
    const isOn = snap.sex === sexOption;
    return (
      <button
        key={sexOption}
        type="button"
        className={`part-chip ${isOn ? "is-selected" : ""}`}
        onClick={() => {
          console.log("[sex] setting sex to", sexOption);
          setSex(sexOption);
        }}
        style={isOn ? { ...baseStyle, ...selectedStyle } : baseStyle}
      >
        {sexOption === "female" ? "Female" : "Male"}
      </button>
    );
  });

  return (
    <div className="section">
      <div
        className="tt-row"
        style={{
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          marginBottom: skinOpen ? 10 : 0,
          flexWrap: "wrap",
        }}
      >
        <div
          className="part-strip in-panel"
          style={{ flexShrink: 0, display: "flex", gap: 6 }}
        >
          {sexButtons}
          {variant === "mobile" && skinToneLabelRow(skinOpen, setSkinOpen)}
        </div>

        {variant === "desktop" && skinToneLabelRow(skinOpen, setSkinOpen)}
      </div>

      {skinOpen && (
        <>
          <div
            className="swatches"
            style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 10 }}
          >
            {SKINS.map((c) => (
              <button
                key={c}
                type="button"
                className={`swatch ${snap.skinColor === c ? "is-selected" : ""}`}
                style={{
                  "--swatch": c,
                  width: 28,
                  height: 28,
                  borderRadius: 8,
                  border: snap.skinColor === c ? "2px solid #ffffff" : "2px solid #333",
                  background: c,
                }}
                onClick={() => (tattoo.skinColor = c)}
                aria-label={c}
              />
            ))}
          </div>
          <SkinTonePicker />
        </>
      )}
    </div>
  );
}
